export function formatDate(value: string | null): string {
  if (!value) return "\u2014";
  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
